











import Popup from '@/views/organisms/Popup.vue'
import store from '@/store'
import BlueButton from '@/views/atoms/BlueButton.vue'

export default
  components: {
    Popup
    BlueButton
  }

  data: () ->
    disabled: false

  props:
    id:
      type: String
      default: ''

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save: () ->
      @disabled = true
      @$emit('save')
  }
